define(function (require) {
  var $ = require("jquery");
  var _ = require("underscore");
  var ga = require("common/analytics/google-analytics");
  var pageConfig = require("common/page-config");
  var xhrUris = require("common/xhr-uris");
  var events = require("common/event-aggregator");
  var windowLoaded = require("common/ready").windowLoaded;
  var accountInformation = require("site/common/user/account-information");
  const cfTurnstile = require("site/common/cf-turnstile");

  var UserProfile = {
    unique (userEmail, callback) {
      var query = {
        "email-address": userEmail
      };

      $.ajax({
        url: xhrUris.profile,
        data: query,
        success: (data) => {
          if (callback) {
            var uniqueEmailResult = data.result !== "AVAILABLE" ? false : true;

            callback(uniqueEmailResult);
          }
        }
      });
    },

    extranetAccount (callback) {
      $.ajax({
        url: xhrUris.extranetAccount,
        success: (data) => {
          if (callback) {
            var extranetAccount = data.data.type === "LINKED" ? data.data : false;

            callback(extranetAccount);
          }
        }
      });
    },

    getData (callback) {
      return $.when(
        $.get(xhrUris.mobileAccountInformation),
        $.get(xhrUris.customerStoredPayment)
      ).done((profile, storedPayment) => {
        var account = _.first(profile);

        if (account.authenticated) {
          windowLoaded(function () {
            accountInformation.track(_.extend({}, account, {
              loginStatus: "PROFILE_AUTHENTICATED"
            }), "authenticationState");
          });
          $(document).trigger("userprofileloaded");
        }

        if (callback) {
          callback(account, storedPayment[0]);
        }
      }).fail((jqXHR, textStatus, errorThrown) => {
        if (callback) {
          callback(errorThrown);
        }
      });
    },

    getPromoCodes (callback) {
      $.get(xhrUris.accountDiscountCodes, (data) => {
        if (callback) {
          callback(data);
        }
      });
    },

    login (email, password, googleToken) {
      const data = {
        email,
        password,
        googleToken,
        cookies: true
      };
      const loginRequestParams = {
        method: "POST",
        url: xhrUris.login,
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        headers: {
          "x-forwarded-host": document.location.host
        }
      };

      return new Promise((resolve, reject) => {
        const requestLogin = () => {
          $.ajax(loginRequestParams)
            .then((response, textStatus, jqXHR) => {
              resolve(response, jqXHR);
              this.handleLogin(jqXHR);
            })
            .fail((...args) => {
              this.handleLogin(args[0]);
              reject(...args);
            });
        };
        // Turnstile only applies where the login page initialised it
        // (TURNSTILE_CAPTCHA_WEB channel feature + a container in the DOM).
        if (googleToken || cfTurnstile.getState() === "uninitialised") {
          requestLogin();
          return;
        }
        cfTurnstile
          .getToken()
          .then((token) => {
            loginRequestParams.headers["x-cf-turnstile-token"] = token;
            requestLogin();
          })
          .catch(reject);
      });
    },

    handleLogin (request) {
      const data = request.responseJSON;
      /* Deliberate split of header name */
      if (request.getResponseHeader("X" + "-Acc" + "ount") === "Limited") {
        data.result = "RATE_LIMITED";
      }

      if (data.authTokens) {
        accountInformation.track(_.extend({}, data, {
          loginStatus: "ACCOUNT_AUTHENTICATED"
        }), "userLoginSuccess");

        // trigger logged in event
        $(document).trigger("userloggedin");
        // track ga event
        ga.trackEvent("site-account", "user-log-in-success");
        // Notify other objects
        events.trigger(events.PROFILE_LOGIN, data);

        if (pageConfig.mobileApp) {
          // set the cache to false because safari mobile is caching the request
          $.ajax({
            type: "GET",
            url: "/wahanda-ios-event/login?accountId=" + data.accountId,
            dataType: "json",
            cache: false
          });
        }
      } else {
        // track ga event
        ga.trackEvent("site-account", "user-log-in-failure");
        events.trigger(events.PROFILE_LOGIN_FAILURE);
        if (window.turnstile && window.turnstile.reset) {
          window.turnstile.reset();
        }
      }
    },

    signout (callback) {
      $.post(xhrUris.logout, (data) => {
        accountInformation.track({}, "userLogoutSuccess");

        if (pageConfig.mobileApp) {
          // set the cache to false because safari mobile is caching the request
          $.ajax({
            type: "GET",
            url: "/wahanda-ios-event/logout",
            dataType: "json",
            cache: false
          });
        }

        events.trigger(events.PROFILE_LOGOUT);

        if (callback) {
          callback(data);
        }
      });
    },

    register (ajaxUri, email, password, callback) {
      var orderId = $("#order-id").val();
      var query = {
        password: password,
        "order-id": orderId
      };

      $.ajax({
        type: "POST",
        url: ajaxUri,
        data: query,
        async: false,

        success: (data) => {
          var STATUS = {
            ok: "success",
            "password-already-set": "already-registerd",
            timeout: "timeout",
            "password-invalid": "pass-invalid"
          };

          if (data.result === "ok") {
            $(document).trigger("newuserregistered");
            UserProfile.login(email, password);
          }

          if (!STATUS[data.result]) {
            if (callback) {
              callback("unknownError");
            }

            return;
          }

          // trigger ga track event
          ga.trackEvent("site-account", `user-register-${STATUS[data.result]}`);

          if (callback) {
            callback(data.result);
          }
        }
      });
    },

    resetPassword (userEmail, callback) {
      var query = { email: userEmail };

      $.ajax({
        type: "POST",
        url: xhrUris.accountPassword,
        data: query,
        success: (data) => {
          var status = data.result === "OK" ? "success" : "failure";

          ga.trackEvent("site-account", `forgotten-password-request-${status}`);

          if (callback) {
            callback(data.result);
          }
        }
      });
    }
  };

  return UserProfile;
});
